import React, { useState } from 'react'
import { Descriptions } from 'antd'
import { Badge, Button } from 'reactstrap'
import moment from 'moment'
import EditDocumentModal from './EditDocumentModal'

const { Item } = Descriptions

export default function DocumentDetailsWidget({ document, reload }) {
	const [showEditModal, setShowEditModal] = useState(false)

	return (
		<React.Fragment>
			<Descriptions size="small" column={1}>
				<Item>
					{document.disabled_at ? <Badge color='danger'>Oculto</Badge> : <Badge color='success'>Visible</Badge>}
				</Item>
				<Item label="Título">{document.title}</Item>
				<Item label="Palabras Clave">{document.keywords}</Item>
				<Item label="ID Documento">#00{document.id}</Item>
				<Item label="URL"><a href={document.url} target="_blank" rel="noopener noreferrer">{document.url}</a></Item>
				<Item label="Fecha Creación">{moment(document.created_at).format('YYYY-MM-DD HH:mm')}</Item>
				<Item label="Fecha Última Modificación">{moment(document.updated_at).format('YYYY-MM-DD HH:mm')}</Item>
			</Descriptions>
			<div className='mt-2'>
				<Button color="primary" outline onClick={() => setShowEditModal(true)}>
					Reemplazar Archivo
				</Button>
			</div>
			{ showEditModal && (
				<EditDocumentModal
					visible
					onClose={() => setShowEditModal(false)}
					document={document}
					reload={() => {
						setShowEditModal(false)
						reload()
					}}
				/>
			)}
		</React.Fragment>
	)
}